module.exports = __webpack_public_path__ + "img/menu-store-2.11c7d59b.webp";